<template>
  <div class="unsuccessful-login-page">
    <div class="unsuccessful-login-page_body">
      <p>
        Login not successfull. Error: access_denied Description: User is not assigned to the client
        application.
      </p>
      <div class="unsuccessful-login-page_body-link-wrapper">
        <a href="#" @click="logout">{{ i18n.t('/HamburgerMenu/Logout') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import authenticationService from '@/services/authenticationService'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    async logout() {
      await authenticationService.logout()
    },
  },
}
</script>

<style lang="scss" scoped>
.unsuccessful-login-page {
  @include center;
  display: flex;
  padding-top: 10rem;
  justify-content: center;
  align-content: center;

  &_body {
    &-link-wrapper {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
